import { render, staticRenderFns } from "./ServiceProviderDetails.vue?vue&type=template&id=ecae2860&"
import script from "./ServiceProviderDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports